export const routes = {
  upload: 'upload',
  download: 'download',
}
